import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllDept = createAsyncThunk(
    'getAllDept/fetchAllDept',
    async (_, { rejectWithValue }) => {
        try {
            const url = api.credentials.department;
            const response = await axiosPrivate.get(url)
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || "Unable to connect to server");
        }
    }
)

const departmentSlice = createSlice({
    name: 'department',
    initialState: {
        department: [],
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchAllDept.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(fetchAllDept.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;

                    const deptExceptions = ["IT", "HR", "PR", "R&D", "QA"];

                    //state.department = action.payload.map(dept => {
                    state.department = action.payload
                        .filter(dept => typeof dept === 'string' || dept.delete !== true)
                        .map(dept => {
                            const rawValue = typeof dept === 'string' ? dept : (dept.departmentName || dept.name || "");

                            const cleanValue = rawValue
                                .replace(/_/g, ' ')
                                .replace(/[^a-zA-Z0-9 ]/g, '')
                                .replace(/\s+/g, ' ')
                                .trim();
                            const transformedValue = cleanValue
                                .split(' ')
                                .map(word => {
                                    const upperWord = word.toUpperCase();
                                    if (deptExceptions.includes(upperWord)) return upperWord;

                                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                                })
                                .join(' ');

                            return typeof dept === 'string'
                                ? transformedValue
                                : { ...dept, departmentName: transformedValue };
                        });
                })
            .addCase(fetchAllDept.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})

export default departmentSlice.reducer;